import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function SyllabusChem() {
  return (
    <>

      <AllSubjectTopics icon="🗺️" subject="chemistry" type="syllabus" book="" />


    </>
  );
}

export default SyllabusChem;